import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/http/api.service';

@Injectable({
  providedIn: 'root',
})
export class EditorService {
  constructor(private http: ApiService) {}

  uploadEditorImage(data: any) {
    return this.http.post('/api/editor-upload/', data);
  }
}
